import { create } from "zustand";

export type RequestStatusValue = -1 | 1 | 2 | 3;

export interface ICheckRequestStatusModalData {
    isCheckReStatusModalOpen: boolean;
    requestStatus: RequestStatusValue;
}

const initData: ICheckRequestStatusModalData = {
    isCheckReStatusModalOpen: false,
    requestStatus: -1,
};


interface ICheckRequestStatusModalStore {
    data: ICheckRequestStatusModalData;
    resetCheckRequestStatusModalData: () => void;
    closeCheckRequestStatusModal: () => void;
    openCheckRequestStatusModal: (requestStatus: RequestStatusValue) => void;
}

export const useCheckReqStatusModalStore = create<ICheckRequestStatusModalStore>()((set) => ({
    data: initData,
    resetCheckRequestStatusModalData: () => set((state) => ({
        ...state,
        data: initData,
    })),
    openCheckRequestStatusModal: (requestStatus: RequestStatusValue) => set((state) => ({
        ...state,
        data: {
            ...state.data,
            requestStatus: requestStatus,
            isCheckReStatusModalOpen: true,
        },
    })),
    closeCheckRequestStatusModal: () => set((state) => ({
        ...state,
        data: {
            ...state.data,
            isCheckReStatusModalOpen: false,
        },
    })),
}));

export const useCheckReqStatusModalData = () => {
    return useCheckReqStatusModalStore((state) => state.data);
}

export const useOpenCheckReqStatusModal = () => {
    return useCheckReqStatusModalStore((state) => state.openCheckRequestStatusModal);
}

export const useCloseCheckReqStatusModal = () => {
    return useCheckReqStatusModalStore((state) => state.closeCheckRequestStatusModal);
}